import React from 'react'
import './index.less'

interface Info {
	courseName: string
	time: string
	lecturer: string
	is_live: boolean
}

class ClassInfo extends React.Component<Info, any> {
	constructor(props: Info) {
		super(props)
		this.state = {
			courseName: props.courseName,
			lecturer: props.lecturer,
			time: props.time,
			is_live: props.is_live,
		}
	}

	public UNSAFE_componentWillReceiveProps(nextProps: Info) {
		this.setState({
			courseName: nextProps.courseName,
			lecturer: nextProps.lecturer,
			time: nextProps.time,
			is_live: nextProps.is_live,
		})
	}

	public render() {
		return (
			<ul className="classInfo">
				<li className="courseName">
					<span>课程名:</span>
					<span>{this.state.courseName}</span>
				</li>
				<li className="lecturer">
					<span>主讲老师:</span>
					<span>{this.state.lecturer}</span>
				</li>
				<li className="time">
					<span>{this.state.is_live ? '上课' : '课程'}时间:</span>
					<span>{this.state.time}</span>
				</li>
			</ul>
		)
	}
}

export default ClassInfo
